<template>
  <div class="Notification-header">
    <p class="Notification-headerTitle">
      Notifications
    </p>
    <div
      v-if="savedItemsCount.totalCount > 0"
      class="Notification-filters"
    >
      <a
        :class="['Notification-filterLink has-items', {'is-active': activeFilter === 'all'}]"
        @click="handleChangeFilter('all')"
      >
        <span>All</span>
      </a>
      <a
        :class="['Notification-filterLink', {'is-active': activeFilter === 'jobs', 'has-items': savedItemsCount.jobsCount > 0 }]"
        @click="handleChangeFilter('jobs')"
      >
        <svg class="Notification-filterIcon">
          <use xlink:href="#Job" />
        </svg>
      </a>
      <a
        :class="['Notification-filterLink', {'is-active': activeFilter === 'reviews', 'has-items': savedItemsCount.reviewsCount > 0}]"
        @click="handleChangeFilter('reviews')"
      >
        <svg class="Notification-filterIcon">
          <use xlink:href="#Review" />
        </svg>
      </a>
      <a
        :class="['Notification-filterLink', {'is-active': activeFilter === 'companies', 'has-items': savedItemsCount.companiesCount > 0}]"
        @click="handleChangeFilter('companies')"
      >
        <svg class="Notification-filterIcon">
          <use xlink:href="#Company" />
        </svg>
      </a>
      <a
        :class="['Notification-filterLink', {'is-active': activeFilter === 'register-interest', 'has-items': savedItemsCount.registerInterestCount > 0 }]"
        @click="handleChangeFilter('register-interest')"
      >
        <svg class="Notification-filterIcon">
          <use xlink:href="#Ryi" />
        </svg>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    activeFilter: {
      type: String,
      default: 'all',
    },
    savedItemsCount: {
      type: Object,
      default: null,
    },
  },
  methods: {
    handleChangeFilter(filter) {
      this.$emit('notification-filter:change-filter', filter);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../scss/abstracts/abstracts";
.Notification-header {
  display: flex;
  padding: 0 1rem;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #e2e2e2;
}
.Notification-headerTitle {
  padding: 1rem 0;
  margin: 0;
}
.Notification-filters {
  display: flex;
  svg {
    width: 16px;
    height: 14px;
  }
}
.Notification-filterLink {
  position: relative;
  cursor: pointer;
  color: #808080;
  padding: 1rem 8px;
  border-bottom: 2px solid transparent;
  .Notification-filterIcon {
    opacity: 0.5;
  }
  &.has-items {
    color:  color($primary-color);
    .Notification-filterIcon {
      opacity: 1;
      fill:   color($primary-color);
    }
  }
  &.is-active {
    /*color:  #005cb3;*/
    background: transparent;
    .Notification-filterIcon {
      opacity: 1;
      /*fill:  #005cb3;*/
    }
    border-color:   color($primary-color);
  }
}
</style>
